import { Card } from "antd";

import { Table } from "#components";
import type { TableColumn } from "#components";

import styles from "./TableCard.module.scss";

interface TableCardProps {
	title: string;
	className?: string;
	columns: TableColumn[];
	dataSource: any[];
	rowKey?: string;
	emptyText?: string;
	onRowClick?: (rowData: Record<string, unknown>) => void;
}

export const TableCard = ({
	title,
	className,
	columns,
	dataSource,
	emptyText = "No data",
	onRowClick,
}: TableCardProps) => (
	<Card
		title={title}
		size="small"
		className={`${styles.tableCard}${className ? ` ${className}` : ""}`}
	>
		<Table
			columns={columns}
			data={dataSource}
			emptyText={emptyText}
			onRowClick={onRowClick}
		/>
	</Card>
);
